function fSubmenu() {
    const aSubmenus = document.querySelectorAll('.js-submenu');
    let windowWidth = window.innerWidth;

    function positionSubmenu(submenu, bounds) {
        if (bounds.right > windowWidth) {
            submenu.classList.add('submenu--right');
        } else {
            submenu.classList.remove('submenu--right');
        }

        if (bounds.left < 0) {
            submenu.classList.add('submenu--left');
        } else {
            submenu.classList.remove('submenu--left');
        }
    }

    function getSubmenus() {
        for (let i = 0; i < aSubmenus.length; i += 1) {
            const bounds = aSubmenus[i].getBoundingClientRect();
            positionSubmenu(aSubmenus[i], bounds);
        }
    }

    getSubmenus();

    window.addEventListener('resize', () => {
        windowWidth = window.innerWidth;
        getSubmenus();
    });
}